// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/iconfont/iconfont.css'
import $ from 'jquery'
import './style/login-new.css'
// import './style/zhanyi.css'
import './style/login.css'
import './style/style.css'
import './style/terms.css'

// import LatticeLottery from 'lattice-lottery'
// import 'lattice-lottery/lib/lattice-lottery.css'
// Vue.use(LatticeLottery)

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);


import axios from 'axios'
Vue.prototype.$axios = axios
import qs from 'qs';
Vue.prototype.$qs = qs;

import ElementUI,{Message} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.prototype.$message = Message
 
import globals from '@/request/global.js'
Vue.prototype.global = globals

Vue.config.productionTip = false


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// end

/* eslint-disable no-new */
new Vue({
  $,
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js